/**
 * Tutorial guidato dei Colori degli stati ordine.
 *
 * Nessun preparativo: il tutorial non apre il selettore del colore, perche' quello
 * cambierebbe il colore di uno stato vero. Il passo illumina la riga e racconta.
 */
const SCOPE = '[data-tour-scope="setting-status-order"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createStatusOrderTourSteps() {
	return [
		{
			body: "Gli stati di un ordine - da pagare, pagato, in preparazione, spedito - sono fissi: non se ne aggiungono e non se ne tolgono. Quello che si decide qui e' il colore con cui ognuno viene mostrato nelle liste, per riconoscerli a colpo d'occhio.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I colori degli stati',
		},
		{
			body: "Un riquadro per stato, con il nome nella lingua del gestionale mostrato come appare nella lista ordini. Cliccando sul riquadro si apre il selettore: si sceglie la tinta guardando l'anteprima e si conferma con «Usa questo colore».",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Scegliere un colore',
		},
		{
			body: "Il colore scelto resta qui finche' non premi Salva configurazione: accanto compare «Modifiche non salvate» per ricordarlo. Vale la pena tenere colori distanti fra loro - due sfumature vicine su stati diversi fanno perdere proprio il vantaggio del colore.",
			key: 'save',
			placement: 'left',
			target: at('save'),
			title: 'Salvare la configurazione',
		},
	];
}
